import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valorProcorPipe'
})
export class ValorProcorPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return null;
        }
        if (value < 10) {
            return '00' + value;
        }
        if (value > 9 && value < 100) {
            return '0' + value;
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/valor-procor.pipe.ts